import { render, staticRenderFns } from "./CareTemplatesModal.vue?vue&type=template&id=4d182153&scoped=true&"
import script from "./CareTemplatesModal.vue?vue&type=script&lang=js&"
export * from "./CareTemplatesModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4d182153",
  null
  
)

export default component.exports